import { get } from 'lodash';

// https://github.com/reduxjs/reselect#accessing-react-props-in-selectors
export default (props, key) =>
  props[key] || get(props, `location.query.${key}`) || get(props, `match.params.${key}`) || get(props, `params.${key}`);
